var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "481.000000pt",
    height: "589.000000pt",
    viewBox: "0 0 481.000000 589.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,589.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415 5861 c-51 -32 -72 -62 -144 -211 -163 -341 -261 -747 -264 -1106 -2 -147 -1 -151 25 -191 33 -50 85 -76 154 -75 60 0 101 19 138 62 35 42 43 79 56 265 6 88 17 189 23 225 l13 65 107 -210 c821 -1614 1981 -3052 3346 -4150 316 -253 671 -511 726 -526 105 -29 209 75 210 211 0 108 -14 125 -226 277 -336 242 -643 488 -964 773 -201 179 -766 745 -947 950 -749 847 -1350 1733 -1857 2740 -147 290 -185 374 -168 364 76 -45 430 -330 641 -517 81 -73 158 -137 170 -144 37 -22 124 -16 171 11 94 56 132 175 83 263 -58 105 -750 675 -1082 892 -69 45 -85 51 -130 51 -32 0 -62 -7 -81 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e4795aef8ace809c57d8e35183546626.svg";
export { ForwardRef as ReactComponent };